module.exports = __webpack_public_path__ + "assets/img/s2_tab3_m.a4d29c2b.png";